import React from "react";
import moment from "moment";

interface IPageWrapperProps {
    Session: string;
}

export const PageWrapper: React.FC<IPageWrapperProps> = props => {
    let SessioneCriptata: string = atob(decodeURIComponent(props.Session));
    const Chiave: string = "pHzY3@=rT&nM+Q6*yvT5V_Zg&7keJy%+UFTM@HPATfHaDVbR@+KNuGbxNjR-v&rDA=Nsju2Qu8_X";
    let Sessione = "";
    for (var C = 0; C < SessioneCriptata.length; C++) {
        Sessione += String.fromCharCode(SessioneCriptata.charCodeAt(C) ^ Chiave.charCodeAt(C));
    }
    if (moment().isAfter(moment(Sessione.substr(0, 19)))) {
        location.replace("https://areariservata.allrisks.it/Login.aspx");
        return null;
    }
    return (
        <div className=" kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor ">
            <div id="kt_header" className="kt-header kt-grid__item kt-header--fixed">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-header-logo float-right kt-padding-t-5">
                        <img alt="Logo" src="images/companies/logo_footer.png" height="56" />
                    </div>
                </div>
            </div>
            {props.children}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/PageWrapper.tsx